module.exports = __webpack_public_path__ + "static/media/offline_screenshot_en.604101f5.png";